import { RequestType } from "@mekidoc/types";

// Re-export all Request types from shared package for backward compatibility
export {
  RequestStatus,
  StatusTranslation,
  StatusPerRequestType,
  RequestType,
  requestTypeExtendedTranslation,
  requestTypeTranslation,
  requestTypeSimplifiedTranslation,
  requestTypeNavigateParser,
  requestTypeFromUrlParser,
} from "@mekidoc/types";

export type {
  Request,
  RequestDetail,
  HistoricRequestCardDetails,
  RequestAttachment,
  RequestCreationPayload,
  NewRequestPayload,
  NewRequestResponse,
} from "@mekidoc/types";

export const RequestTypeColorMapper: Record<RequestType, string> = {
  [RequestType.PRESCRIPTION]: "#41BBF0",
  [RequestType.COMPOUNDED_PRESCRIPTION]: "#7BECFE",
  [RequestType.MEDICAL_ORDER]: "#25257F",
  [RequestType.MEDICAL_CERTIFICATE]: "#7355FB",
};
